module.exports = __webpack_public_path__ + "static/addons-allowances-c9c584b54e663734b32f2af06f1f35bc.svg";